import React, { useEffect } from "react";
import Plista from "../vendor/Plista";
import GoogleRecomendations from "../vendor/GoogleRecomendations";
import AdsByGoogle from "../vendor/AdsByGoogle"
import { IS_TABOOLA } from "../../common/constants/constants";

// export default class ArticleRecomendations extends React.Component {
// 	render() {
// 		if (window.TESTING_MODE) {
// 			return null;
// 		}

// 		if (window.BRAND == 'innpoland' || window.BRAND == 'mamadu' || window.BRAND == 'dadhero') {
// 			return <GoogleRecomendations />
// 		} else {
// 			return <Plista />;
// 		}

// 	}
// }

const ArticleRecommendations = () => {
	if (window.TESTING_MODE) {
		return null;
	} else if (window.BRAND === "aszdziennik" && !IS_TABOOLA) {
		return <AdsByGoogle />;
	} else {
		return null
	}
}

export default ArticleRecommendations